var map = {
	"./au/au_02_code.png": 11575,
	"./au/au_03_code.png": 78824,
	"./au/au_07_code.png": 46852,
	"./au/au_08_code.png": 19901,
	"./au/au_act_bus_stop.png": 32467,
	"./au/au_act_sign.png": 86717,
	"./au/au_darwin.png": 29248,
	"./au/au_flat_signpost.png": 70880,
	"./au/au_nsw_bus_stop.png": 12139,
	"./au/au_nsw_guardrail_ending.png": 43533,
	"./au/au_nsw_no_stopping.png": 87764,
	"./au/au_nsw_plate.png": 47064,
	"./au/au_nsw_pole.png": 23592,
	"./au/au_nsw_speed_limit.png": 15157,
	"./au/au_nt_pole.png": 54966,
	"./au/au_nt_speed_limit.png": 99163,
	"./au/au_nt_sticker.png": 82187,
	"./au/au_nt_termite_mound.png": 78362,
	"./au/au_qld_blue_sticker.png": 63249,
	"./au/au_qld_bus_stop.png": 5308,
	"./au/au_qld_outline.png": 23227,
	"./au/au_qld_plate.png": 99425,
	"./au/au_qld_pole.png": 85695,
	"./au/au_qld_pole_marking.png": 67391,
	"./au/au_qld_pole_top.png": 90499,
	"./au/au_roadline_gap.png": 80692,
	"./au/au_sa_bus_stop.png": 35243,
	"./au/au_sa_pole.png": 14440,
	"./au/au_sa_school_zone.png": 13909,
	"./au/au_sa_white_marker.png": 142,
	"./au/au_short_reflector.png": 91718,
	"./au/au_sydney_pole.png": 37116,
	"./au/au_tas_bus_stop.png": 5027,
	"./au/au_tas_c_road.png": 46238,
	"./au/au_tas_possom_guard.png": 54469,
	"./au/au_tas_white_sign.png": 99167,
	"./au/au_thin_keep_left.png": 13396,
	"./au/au_traffic_light_outline.png": 77156,
	"./au/au_trident_pole.png": 10108,
	"./au/au_vic_concrete_pole.png": 25164,
	"./au/au_vic_hydrant.png": 38192,
	"./au/au_vic_hydrant_pole.png": 33571,
	"./au/au_vic_pole_top.png": 38286,
	"./au/au_victoria_bus_stop.png": 87230,
	"./au/au_wa_bollard.png": 97208,
	"./au/au_wa_bus_stop.png": 37087,
	"./au/au_wa_green_marker.png": 90668,
	"./au/au_wa_green_pole.png": 62920,
	"./au/au_wa_kerb.png": 9414,
	"./au/au_wa_plant.png": 52651,
	"./au/au_wa_red_soil.png": 19327,
	"./au/au_wa_signpost.png": 20483,
	"./au/au_wa_striped_bollard.png": 12364,
	"./br/br_1_code.png": 4990,
	"./br/br_2_code.png": 34023,
	"./br/br_3_code.png": 25400,
	"./br/br_4_code.png": 49761,
	"./br/br_5_code.png": 4826,
	"./br/br_61_code.png": 42644,
	"./br/br_6_code.png": 80483,
	"./br/br_7_code.png": 39860,
	"./br/br_8_code.png": 30221,
	"./br/br_9_code.png": 31238,
	"./br/br_acai_palm.png": 35992,
	"./br/br_acre_68.png": 3245,
	"./br/br_acre_houses.png": 41448,
	"./br/br_acre_landscape.png": 50296,
	"./br/br_acre_red_brick_road.png": 10723,
	"./br/br_alagoas_82.png": 26990,
	"./br/br_amapa_96.png": 11597,
	"./br/br_amapa_gen4.png": 95638,
	"./br/br_amazonas_code.png": 31549,
	"./br/br_bahia_insulators.png": 16993,
	"./br/br_bahia_pole_marking.png": 70101,
	"./br/br_carnauba_palm.png": 24737,
	"./br/br_ceara_code.png": 95679,
	"./br/br_cobblestone_pavement.png": 59838,
	"./br/br_concrete_trash_bin.png": 20513,
	"./br/br_es_mountains.png": 18832,
	"./br/br_goias_code.png": 83972,
	"./br/br_goias_pole_marking.png": 45689,
	"./br/br_hexagonal_pavement.png": 82301,
	"./br/br_hilly_landscape.png": 94361,
	"./br/br_horizontal_insulators.png": 60820,
	"./br/br_lollipop_insulators.png": 65851,
	"./br/br_macaw_palms.png": 55658,
	"./br/br_maranhao_code.png": 87444,
	"./br/br_maranhao_plate.png": 48359,
	"./br/br_maranhao_pole.png": 21341,
	"./br/br_mg_code.png": 57733,
	"./br/br_mg_pole.png": 30476,
	"./br/br_mgds_67.png": 8414,
	"./br/br_paraiba_83.png": 44933,
	"./br/br_parana_pines.png": 93264,
	"./br/br_parana_street_name_pole.png": 58327,
	"./br/br_pernambuco_87.png": 89911,
	"./br/br_pernambuco_insulators.png": 40358,
	"./br/br_piaui_gravel.png": 46607,
	"./br/br_random_cobblestone.png": 30639,
	"./br/br_rgds_landscape.png": 52821,
	"./br/br_rgds_square_pavement.png": 79580,
	"./br/br_rn_84.png": 43522,
	"./br/br_rondonia_69.png": 74275,
	"./br/br_roraima_95.png": 27219,
	"./br/br_roraima_landscape.png": 49978,
	"./br/br_sergipe_79.png": 44875,
	"./br/br_southern_architecture.png": 4035,
	"./br/br_sp_divided_highway.png": 71720,
	"./br/br_sp_km_marker.png": 7684,
	"./br/br_sp_round_pole.png": 79296,
	"./br/br_square_uneven_pavement.png": 88831,
	"./br/br_tall_grass.png": 5891,
	"./br/br_tocantins_63.png": 81626,
	"./br/br_transparent_insulators.png": 47334,
	"./br/br_wooden_pole.png": 56902,
	"./br/br_yellow_pole_plate.png": 96269,
	"./ca/ca_acadia.png": 93364,
	"./ca/ca_alberta_bollard.png": 77335,
	"./ca/ca_alberta_guardrails.png": 45261,
	"./ca/ca_alberta_plate.png": 87891,
	"./ca/ca_alberta_pole.png": 73713,
	"./ca/ca_alberta_pole_missing_insulator.png": 92946,
	"./ca/ca_alberta_road_names.png": 47524,
	"./ca/ca_alberta_rumble_outer.png": 20856,
	"./ca/ca_bc_asym_insulators.png": 67178,
	"./ca/ca_bc_barriers.png": 72921,
	"./ca/ca_bc_bollard.png": 6973,
	"./ca/ca_bc_green_backs.png": 66301,
	"./ca/ca_bc_metal_circles.png": 106,
	"./ca/ca_bc_plate_sticker.png": 89933,
	"./ca/ca_bc_pole_sticker.png": 93215,
	"./ca/ca_bc_signposts.png": 19921,
	"./ca/ca_bc_speed_limit_sign.png": 89986,
	"./ca/ca_bc_tilted_insulators.png": 90754,
	"./ca/ca_canola.png": 99801,
	"./ca/ca_eastern_pole.png": 22480,
	"./ca/ca_manitoba_area_code.png": 4532,
	"./ca/ca_manitoba_aspen.png": 82696,
	"./ca/ca_manitoba_bollard.png": 573,
	"./ca/ca_manitoba_gravel.png": 90892,
	"./ca/ca_manitoba_lamp.png": 98999,
	"./ca/ca_manitoba_plate.png": 66733,
	"./ca/ca_manitoba_pole.png": 40643,
	"./ca/ca_manitoba_road_names.png": 79350,
	"./ca/ca_manitoba_sask_bollard.png": 33902,
	"./ca/ca_manitoba_sticker.png": 19788,
	"./ca/ca_nb_area_code.png": 34953,
	"./ca/ca_nb_bollard.png": 23060,
	"./ca/ca_nb_double_insulator.png": 18467,
	"./ca/ca_nb_plate.png": 59488,
	"./ca/ca_nb_pole_sticker.png": 43308,
	"./ca/ca_nb_square_lamp.png": 61738,
	"./ca/ca_nb_stop_sign.png": 7312,
	"./ca/ca_newfoundland_balsam_fir.png": 91897,
	"./ca/ca_newfoundland_hydrant_sign.png": 51231,
	"./ca/ca_newfoundland_intersection_border.png": 21253,
	"./ca/ca_newfoundland_pyramid_guardrail_top.png": 56915,
	"./ca/ca_newfoundland_wooden_bin.png": 23545,
	"./ca/ca_nl_area_code.png": 26467,
	"./ca/ca_nl_route_line.png": 49744,
	"./ca/ca_ns_area_code.png": 28392,
	"./ca/ca_ns_bollard.png": 71945,
	"./ca/ca_ns_double_yellow.png": 72551,
	"./ca/ca_ns_lamp.png": 57035,
	"./ca/ca_ns_nb_wire_sticker.png": 49849,
	"./ca/ca_ns_plate.png": 65889,
	"./ca/ca_ns_signage.png": 7597,
	"./ca/ca_ns_transformer.png": 17240,
	"./ca/ca_ontario_fences.png": 32176,
	"./ca/ca_ontario_holed_signposts.png": 63131,
	"./ca/ca_ontario_house_number.png": 23654,
	"./ca/ca_ontario_hydrant.png": 91958,
	"./ca/ca_ontario_marker.png": 19084,
	"./ca/ca_ontario_pole_sticker.png": 23028,
	"./ca/ca_ontario_pole_top.png": 29260,
	"./ca/ca_ontario_silo.png": 92533,
	"./ca/ca_ontario_speed_limit_sign.png": 85685,
	"./ca/ca_ontario_traffic_cone.png": 88873,
	"./ca/ca_ontario_traffic_light.png": 61146,
	"./ca/ca_parallel_transformer.png": 35848,
	"./ca/ca_pei_pole_sticker.png": 16538,
	"./ca/ca_pei_red_soil.png": 7529,
	"./ca/ca_pei_transformer.png": 3635,
	"./ca/ca_quebec_bollard.png": 39719,
	"./ca/ca_quebec_chevron.png": 84094,
	"./ca/ca_quebec_cross.png": 47487,
	"./ca/ca_quebec_double_signpost.png": 95544,
	"./ca/ca_quebec_horizontal.png": 41559,
	"./ca/ca_quebec_hydrant.png": 84837,
	"./ca/ca_quebec_intersection_sign.png": 61766,
	"./ca/ca_quebec_marker.png": 43497,
	"./ca/ca_quebec_pole.png": 79265,
	"./ca/ca_quebec_pole_label.png": 77002,
	"./ca/ca_quebec_pole_top.png": 50293,
	"./ca/ca_quebec_speed_limit_sign.png": 6900,
	"./ca/ca_quebec_stop_sign.png": 81819,
	"./ca/ca_quebec_traffic_cone.png": 15684,
	"./ca/ca_quebec_traffic_light.png": 43141,
	"./ca/ca_sask_area_code.png": 5239,
	"./ca/ca_sask_green_lamppost.png": 73308,
	"./ca/ca_sask_lamp.png": 15694,
	"./ca/ca_sask_plate.png": 7078,
	"./ca/ca_sask_pole_sticker.png": 55750,
	"./ca/ca_sask_pole_tops.png": 82251,
	"./ca/ca_sask_roadlines.png": 45453,
	"./ca/ca_sask_signpost_triangles.png": 19907,
	"./ca/ca_sask_white_signpost.png": 9815,
	"./ca/ca_south_ontario_sign.png": 52163,
	"./ca/ca_west_ont_code.png": 96682,
	"./ca/ca_yukon_trees.png": 13085,
	"./home/au.jpg": 79933,
	"./home/auflag.png": 35415,
	"./home/br.png": 5687,
	"./home/brflag.png": 40433,
	"./home/ca.png": 83187,
	"./home/caflag.png": 81029,
	"./home/idflag.png": 3118,
	"./home/jpflag.png": 52791,
	"./home/myflag.png": 59535,
	"./home/usflag.png": 12577,
	"./id/id_aceh_pole.png": 29131,
	"./id/id_aframe.png": 6879,
	"./id/id_asym_2_support.png": 51346,
	"./id/id_bali_architecture.png": 97311,
	"./id/id_bali_connector.png": 13653,
	"./id/id_bangka_pole.png": 66448,
	"./id/id_bangka_pole2.png": 30464,
	"./id/id_bangka_red_soil.png": 14363,
	"./id/id_bengkulu_pole.png": 92719,
	"./id/id_cjava_pavement.png": 30215,
	"./id/id_cjava_pole.png": 91055,
	"./id/id_cjava_pole2.png": 61581,
	"./id/id_cjava_pole3.png": 85303,
	"./id/id_cjava_pole4.png": 71547,
	"./id/id_cjava_sticker.png": 91224,
	"./id/id_ckali_band.png": 83843,
	"./id/id_csula_bollard.png": 33072,
	"./id/id_ejava_pole.png": 80497,
	"./id/id_ekali_band.png": 93461,
	"./id/id_gable_horns.png": 74871,
	"./id/id_java_antenna.png": 13823,
	"./id/id_java_tiled_roofs.png": 28018,
	"./id/id_kali_bridge.png": 72848,
	"./id/id_kali_pole.png": 71881,
	"./id/id_kali_roof.png": 13141,
	"./id/id_maluku_pole.png": 83979,
	"./id/id_metal_roof.png": 23921,
	"./id/id_nias_cabbage.png": 4448,
	"./id/id_nkali_haze.png": 74811,
	"./id/id_nsula_pole.png": 67911,
	"./id/id_nsuma_roof.png": 63846,
	"./id/id_nsumatra_pole.png": 41827,
	"./id/id_nusas_dryness.png": 5746,
	"./id/id_nusas_pole.png": 93368,
	"./id/id_oil_plantation.png": 758,
	"./id/id_riau_lpoles.png": 89206,
	"./id/id_riau_pipe.png": 30687,
	"./id/id_riau_pole.png": 20557,
	"./id/id_riau_xpole.png": 73853,
	"./id/id_rice_field.png": 80993,
	"./id/id_ssula_pole.png": 96588,
	"./id/id_ssula_roof.png": 83684,
	"./id/id_ssula_smudge.png": 15277,
	"./id/id_ssuma_pole.png": 95201,
	"./id/id_sula_black_car.png": 73373,
	"./id/id_sula_fences.png": 74169,
	"./id/id_sumba_roof.png": 14776,
	"./id/id_sumba_savannah.png": 96306,
	"./id/id_wjava_pole.png": 8555,
	"./id/id_wjava_pole2.png": 67857,
	"./id/id_wjava_sticker.png": 7780,
	"./id/id_wjava_triangle.png": 72525,
	"./id/id_wkali_pole.png": 49812,
	"./id/id_wsula_pole.png": 36688,
	"./id/id_wsuma_nagari.png": 27835,
	"./id/id_wsuma_pole.png": 51429,
	"./id/id_wsuma_roof.png": 69009,
	"./id/id_yellow_band.png": 47301,
	"./jp/jp_aichi_stripes.png": 95070,
	"./jp/jp_aichi_tomare.png": 28300,
	"./jp/jp_akita_bollard.png": 27676,
	"./jp/jp_akita_sticker.png": 117,
	"./jp/jp_akita_striped_bollard.png": 95552,
	"./jp/jp_aomori_pole.png": 67097,
	"./jp/jp_bamboo.png": 82133,
	"./jp/jp_chubu_brackets.png": 54722,
	"./jp/jp_chubu_guywire.png": 6224,
	"./jp/jp_chubu_pole_plate.png": 91530,
	"./jp/jp_chubu_pole_top.png": 82695,
	"./jp/jp_chubu_reflector.png": 50961,
	"./jp/jp_chubu_transformers.png": 34821,
	"./jp/jp_chubu_tuning_fork.png": 32503,
	"./jp/jp_chugoku_guardrail_ending.png": 34993,
	"./jp/jp_chugoku_guywire.png": 19298,
	"./jp/jp_chugoku_pole_plate.png": 31409,
	"./jp/jp_chugoku_pole_top.png": 25984,
	"./jp/jp_chugoku_red_roof.png": 31840,
	"./jp/jp_chugoku_reflector.png": 79060,
	"./jp/jp_chugoku_transformer.png": 62569,
	"./jp/jp_chugoku_transformer_numbers.png": 74642,
	"./jp/jp_ehime_blue_road_line.png": 39334,
	"./jp/jp_fukuoka_manhole.png": 28364,
	"./jp/jp_fukuoka_sticker.png": 59123,
	"./jp/jp_fukushima_tomare.png": 48171,
	"./jp/jp_gifu_sticker.png": 1742,
	"./jp/jp_gifu_tomare.png": 69041,
	"./jp/jp_green_bands.png": 42393,
	"./jp/jp_gunma_sticker.png": 15201,
	"./jp/jp_gunma_v_sticker.png": 42822,
	"./jp/jp_hokkaido_arrow.png": 63607,
	"./jp/jp_hokkaido_band.png": 38291,
	"./jp/jp_hokkaido_cabbage.png": 9753,
	"./jp/jp_hokkaido_chevron.png": 60389,
	"./jp/jp_hokkaido_double_bar.png": 97419,
	"./jp/jp_hokkaido_plus_bar.png": 29272,
	"./jp/jp_hokkaido_pole_plate.png": 60997,
	"./jp/jp_hokkaido_square_bar.png": 29469,
	"./jp/jp_hokuriku_pole_plate.png": 80969,
	"./jp/jp_hokuriku_pole_top.png": 95832,
	"./jp/jp_hokuriku_reflector.png": 61340,
	"./jp/jp_hokuriku_transformers.png": 78046,
	"./jp/jp_hot_water_tank.png": 54849,
	"./jp/jp_hyogo_pole.png": 44338,
	"./jp/jp_ibaraki_tag.png": 81625,
	"./jp/jp_insulator_blocks.png": 83017,
	"./jp/jp_iwate_sticker.png": 33325,
	"./jp/jp_kagawa_sign.png": 77989,
	"./jp/jp_kagoshima_tomare.png": 19234,
	"./jp/jp_kanagawa_sticker.png": 1894,
	"./jp/jp_kansai_guywire.png": 1585,
	"./jp/jp_kansai_pole.png": 17829,
	"./jp/jp_kansai_pole2.png": 25779,
	"./jp/jp_kansai_pole_plate.png": 7016,
	"./jp/jp_kansai_reflector.png": 6239,
	"./jp/jp_kansai_transformer.png": 41642,
	"./jp/jp_kansai_tuning_fork.png": 46177,
	"./jp/jp_kanto_pole_plate.png": 30878,
	"./jp/jp_kanto_pole_top.png": 73891,
	"./jp/jp_kanto_round_plate.png": 48540,
	"./jp/jp_kanto_transformers.png": 81633,
	"./jp/jp_kerosene_tanks.png": 68145,
	"./jp/jp_kitakyushu_manhole.png": 74910,
	"./jp/jp_kumamoto_manhole.png": 9919,
	"./jp/jp_kumamoto_sticker.png": 62404,
	"./jp/jp_kyushu_bollard.png": 39773,
	"./jp/jp_kyushu_grass.png": 56603,
	"./jp/jp_kyushu_guywire.png": 94235,
	"./jp/jp_kyushu_pole_plate.png": 80722,
	"./jp/jp_kyushu_reflector.png": 67529,
	"./jp/jp_kyushu_tomare.png": 52563,
	"./jp/jp_kyushu_transformer.png": 49372,
	"./jp/jp_matsumoto_manhole.png": 54071,
	"./jp/jp_miyagi_sticker.png": 72601,
	"./jp/jp_miyagi_stripe.png": 86957,
	"./jp/jp_nagano_signpost.png": 7293,
	"./jp/jp_nagasaki_back_sticker.png": 58866,
	"./jp/jp_nagasaki_sticker.png": 17758,
	"./jp/jp_nagasaki_tomare.png": 3265,
	"./jp/jp_nagoya_manhole.png": 38621,
	"./jp/jp_nara_chevron.png": 31377,
	"./jp/jp_nara_manhole.png": 65578,
	"./jp/jp_niigata_manhole.png": 43115,
	"./jp/jp_niigata_snow_pole.png": 95275,
	"./jp/jp_niigata_tomare.png": 64695,
	"./jp/jp_northern_roof.png": 34634,
	"./jp/jp_oita_sticker.png": 67648,
	"./jp/jp_okayama_bollard.png": 85911,
	"./jp/jp_okayama_manhole.png": 63781,
	"./jp/jp_okayama_sticker.png": 71650,
	"./jp/jp_okinawa_architecture.png": 97663,
	"./jp/jp_okinawa_pole_plate.png": 27557,
	"./jp/jp_okinawa_transformer.png": 87997,
	"./jp/jp_osaka_manhole.png": 88285,
	"./jp/jp_osaka_sticker.png": 74666,
	"./jp/jp_rice.png": 76666,
	"./jp/jp_saga_stripes.png": 91734,
	"./jp/jp_sakai_manhole.png": 99363,
	"./jp/jp_sapporo_manhole.png": 24056,
	"./jp/jp_sendai_manhole.png": 69974,
	"./jp/jp_shiga_tomare.png": 754,
	"./jp/jp_shikoku_attachment.png": 62145,
	"./jp/jp_shikoku_bollard.png": 97248,
	"./jp/jp_shikoku_pole_plate.png": 16265,
	"./jp/jp_shikoku_reflector.png": 92732,
	"./jp/jp_shikoku_sticker.png": 78153,
	"./jp/jp_shikoku_transformer.png": 45377,
	"./jp/jp_shizuoka_sticker.png": 95909,
	"./jp/jp_snow_prevention_road.png": 95900,
	"./jp/jp_sugar_cane.png": 41055,
	"./jp/jp_tea_hedge.png": 22613,
	"./jp/jp_tochigi_sticker.png": 23094,
	"./jp/jp_tohoku_bollard.png": 64228,
	"./jp/jp_tohoku_circle_plate.png": 52927,
	"./jp/jp_tohoku_logo.png": 93691,
	"./jp/jp_tohoku_pole_plate.png": 67389,
	"./jp/jp_tohoku_reflector.png": 98288,
	"./jp/jp_tohoku_square_bar.png": 67429,
	"./jp/jp_tohoku_square_brackets.png": 43387,
	"./jp/jp_tokyo_manhole.png": 83812,
	"./jp/jp_tokyo_sticker.png": 74139,
	"./jp/jp_tottori_sticker.png": 88092,
	"./jp/jp_toyama_bollard.png": 27375,
	"./jp/jp_vertical_traffic_light.png": 61776,
	"./jp/jp_white_birch.png": 48397,
	"./jp/jp_yamagata_bands.png": 39565,
	"./jp/jp_yamagata_sticker.png": 15712,
	"./jp/jp_yamaguchi_yellow_guardrail.png": 18258,
	"./jp/jp_yamanashi_stripes.png": 16637,
	"./jp/jp_yokohama_manhole.png": 79239,
	"./mx/mx_durango_pole.png": 63648,
	"./my/my_2ndlineletter_sticker.png": 88523,
	"./my/my_3char_sticker.png": 60750,
	"./my/my_black_car.png": 92839,
	"./my/my_gen_4.png": 6110,
	"./my/my_johor_flag.png": 12408,
	"./my/my_johor_sign.png": 93669,
	"./my/my_johor_sticker.png": 85237,
	"./my/my_kedah_bin.png": 15136,
	"./my/my_kedah_flag.png": 16077,
	"./my/my_kedah_rift.png": 75822,
	"./my/my_kelantan_flag.png": 17226,
	"./my/my_kl_bin.png": 77598,
	"./my/my_kuching_sign.png": 56772,
	"./my/my_lightbulb_sticker.png": 61084,
	"./my/my_mainland_bollard.png": 68788,
	"./my/my_mainland_lamp_post.png": 68275,
	"./my/my_mainland_sticker.png": 47805,
	"./my/my_malacca_bin.png": 70413,
	"./my/my_malacca_flag.png": 35346,
	"./my/my_malacca_sticker.png": 46307,
	"./my/my_negeri_sembilan_flag.png": 18220,
	"./my/my_pahang_flag.png": 96123,
	"./my/my_penang_flag.png": 18437,
	"./my/my_perak_flag.png": 85475,
	"./my/my_perlis_flag.png": 50397,
	"./my/my_perlis_rock_formation.png": 47944,
	"./my/my_perlis_sticker.png": 56302,
	"./my/my_rb_paint.png": 29500,
	"./my/my_sabah_flag.png": 97271,
	"./my/my_sabah_mountain.png": 86760,
	"./my/my_sabah_pole.png": 51803,
	"./my/my_sabah_pole2.png": 10977,
	"./my/my_sabah_sign.png": 9942,
	"./my/my_sarawak_bin.png": 57989,
	"./my/my_sarawak_flag.png": 170,
	"./my/my_sarawak_lamp.png": 15838,
	"./my/my_sarawak_pole.png": 89030,
	"./my/my_sarawak_sticker.png": 38875,
	"./my/my_sarawak_traffic_light.png": 19440,
	"./my/my_selangor_flag.png": 68005,
	"./my/my_tel_sticker.png": 23086,
	"./my/my_terengganu_flag.png": 83664,
	"./my/my_triangle_support.png": 49697,
	"./us/us_alabama_overpass_marker.png": 7655,
	"./us/us_alabama_overpass_stripes.png": 65991,
	"./us/us_alabama_plate.png": 97841,
	"./us/us_alaska_code.png": 81708,
	"./us/us_alaska_plate.png": 24623,
	"./us/us_arizona_plate.png": 81300,
	"./us/us_california_black_middle_line.png": 48934,
	"./us/us_california_pole_stripes.png": 38033,
	"./us/us_california_postal_marker.png": 57528,
	"./us/us_connecticut_plate.png": 86609,
	"./us/us_delaware_code.png": 66348,
	"./us/us_delaware_plate.png": 11887,
	"./us/us_diamond_bollard.png": 40872,
	"./us/us_florida_plate.png": 30151,
	"./us/us_green_reference_marker.png": 61946,
	"./us/us_green_reference_marker2.png": 36843,
	"./us/us_hawaii_code.png": 76144,
	"./us/us_hawaii_pole_sticker.png": 36401,
	"./us/us_idaho_code.png": 38068,
	"./us/us_idaho_plate.png": 34375,
	"./us/us_illinois_sign.png": 54056,
	"./us/us_indiana_blue_sign.png": 68398,
	"./us/us_indiana_plate.png": 49630,
	"./us/us_iowa_concrete_highway.png": 27863,
	"./us/us_iowa_plate.png": 33724,
	"./us/us_kansas_signpost_reflector.png": 39381,
	"./us/us_louisiana_parish.png": 42034,
	"./us/us_louisiana_thick_stripes.png": 38577,
	"./us/us_maine_code.png": 1957,
	"./us/us_massachusetts_plate.png": 30252,
	"./us/us_michigan_double_signpost.png": 22369,
	"./us/us_michigan_hanging_sign.png": 73808,
	"./us/us_minnesota_bnw_marker.png": 99998,
	"./us/us_minnesota_triangle_bridge_sign.png": 67282,
	"./us/us_mississippi_overpass_bridge_plaque.png": 5459,
	"./us/us_mississippi_yellow_direction_box.png": 51281,
	"./us/us_missouri_letter_county_road.png": 35053,
	"./us/us_montana_code.png": 82489,
	"./us/us_nevada_bollard.png": 47601,
	"./us/us_nevada_bollard2.png": 16695,
	"./us/us_nevada_mile_marker.png": 57561,
	"./us/us_nevada_plate.png": 96841,
	"./us/us_new_hampshire_code.png": 24093,
	"./us/us_new_hampshire_interstate_marker.png": 59794,
	"./us/us_new_hampshire_plate.png": 4316,
	"./us/us_new_hampshire_us_route_marker.png": 51611,
	"./us/us_new_jersey_plate.png": 50185,
	"./us/us_new_mexico_plate.png": 62684,
	"./us/us_north_carolina_arrow_sign.png": 64470,
	"./us/us_north_carolina_white_sign.png": 44050,
	"./us/us_north_dakota_code.png": 72299,
	"./us/us_number_direction_street_name.png": 26612,
	"./us/us_oklahoma_green_stop_sign_back.png": 70882,
	"./us/us_oklahoma_green_stop_sign_back2.png": 18794,
	"./us/us_oregon_plate.png": 6400,
	"./us/us_oregon_speed.png": 73533,
	"./us/us_pennsylvania_sr_sign.png": 90809,
	"./us/us_pennsylvania_sr_sign2.png": 66799,
	"./us/us_pueblo_revival_house.png": 37415,
	"./us/us_raised_pavement_marker.png": 89883,
	"./us/us_rectangle_bridge_sign.png": 2618,
	"./us/us_rhode_island_code.png": 54009,
	"./us/us_rock_walls.png": 31476,
	"./us/us_snowplowable_marker.png": 89429,
	"./us/us_south_carolina_black_sign.png": 64234,
	"./us/us_south_carolina_overpass_stripes.png": 14651,
	"./us/us_south_dakota_code.png": 15469,
	"./us/us_south_dakota_plate.png": 45164,
	"./us/us_square_guardrail.png": 76822,
	"./us/us_tennessee_mile_marker.png": 83422,
	"./us/us_texas_band.png": 88518,
	"./us/us_texas_band2.png": 4038,
	"./us/us_texas_grainy_roads.png": 67065,
	"./us/us_thick_middle_lines.png": 69012,
	"./us/us_utah_plate.png": 42436,
	"./us/us_vermont_code.png": 41742,
	"./us/us_vermont_plate.png": 20741,
	"./us/us_virginia_white_sign.png": 95516,
	"./us/us_washington_plate.png": 3618,
	"./us/us_west_virginia_fraction_sign.png": 41299,
	"./us/us_wide_middle_gap.png": 703,
	"./us/us_wisconsin_bollard.png": 50193,
	"./us/us_wisconsin_driveway_sign.png": 6014,
	"./us/us_wisconsin_pole_plate.png": 65318,
	"./us/us_wisconsin_pole_plate2.png": 50374,
	"./us/us_wyoming_code.png": 38973,
	"./us/us_wyoming_plate.png": 6556,
	"./us/us_yellow_plate.png": 52812
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46133;